<template>
	<div
		class="g-block-title-framed g-block-title-padding"
		:class="{
			'g-block-title-framed--edit': editable,
			'is-active': editable && active,
			'g-block-title-framed--h5': h5,
			'g-block-title-padding--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div class="g-block-title-framed__frame" :style="{ borderColor: themeColor }">
			<div class="g-block-title-framed__inner" :style="{ background: themeColor }">
				<RichTextEditable
					v-if="editable"
					class="g-block-title-framed__text"
					fit-content
					:model-value="data.content"
					placeholder="请输入标题"
					@update:model-value="onContentUpdate"
					@focus="onWrapClick"
				/>
				<div
					v-else
					class="g-block-title-framed__text"
					v-html="data.content || ''"
				></div>
			</div>
		</div>
	</div>
</template>

<script>
	import RichTextEditable from '../../../components/RichTextEditable.vue';
	import { singleTitleMixin } from '../shared/singleTitleMixin.js';

	export default {
		name: 'GBlockTitleFramed',
		components: { RichTextEditable },
		mixins: [singleTitleMixin],
	};
</script>

<style scoped lang="less">
	@import '../shared/titleEditShell.less';

	.g-block-title-framed {
		.title-block-edit-shell();
		text-align: center;
	}

	.g-block-title-framed__frame {
		display: inline-flex;
		padding: 6px;
		border: 1px solid;
		box-sizing: border-box;
	}

	.g-block-title-framed__inner {
		padding: 12px 24px;
	}

	.g-block-title-framed__text {
		font-size: 18px;
		font-weight: 700;
		line-height: 1.3;
		color: #fff;
		text-align: center;
		:deep(.g-rich-text-editable__content) {
			min-height: unset;
			padding: 0;
			font-weight: 700;
			color: inherit;
			text-align: center;
		}
	}

	.g-block-title-framed--h5 {
		.g-block-title-framed__frame { padding: 0.12rem; }
		.g-block-title-framed__inner { padding: 0.24rem 0.48rem; }
		.g-block-title-framed__text { font-size: 0.36rem; }
	}
</style>
